import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import "./login.css";
import axios from "axios";
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import { FaUser } from "react-icons/fa6";
import { IoEye, IoEyeOff } from "react-icons/io5";
import logo from '../Assets/2xsmartlogo1.png';
import smart_logo from '../Assets/Logo.png';


function Login() {
    const [value, setvalue] = useState({ uname: '', password: '' });
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();

    const inval = (e) => {
        setvalue(prev => ({ ...prev, [e.target.id]: e.target.value }));
    };
    const submit = async (e) => {
        e.preventDefault();
        if (value.uname && value.password) {
            try {
                const res = await axios.post("/login/check", value);
                if (!res.data) {
                    return toast.error("Please Check User Name and Password", { autoClose: 2000 });
                }
                const { level, connect_id } = res.data;
                if (level === 'Super Admin') {
                    Cookies.set('user', `Super Admin`, { expires: 1 });
                    Cookies.set('name', `Super Admin`, { expires: 1 });
                    Cookies.set('path', `/company`, { expires: 1 });
                    Cookies.set('level', `Super Admin`, { expires: 1 });
                    navigate(`/company`);
                }
                else if (level === 'Admin') {
                    const companyRes = await axios.get(`/company/${connect_id}`);
                    Cookies.set('user', `Admin`, { expires: 1 });
                    Cookies.set('name', companyRes.data.name, { expires: 1 });
                    Cookies.set('path', `/integ/${connect_id}`, { expires: 1 });
                    Cookies.set('level', `Admin`, { expires: 1 });
                    navigate(`/integ/${connect_id}`);
                } else {
                    const userRes = await axios.get(`/user/check/${connect_id}`);
                    Cookies.set('name', userRes.data.role, { expires: 1 });
                    Cookies.set('user', `User`, { expires: 1 });
                    Cookies.set('path', `/integ/${userRes.data.com_id}`, { expires: 1 });
                    Cookies.set('level', userRes.data.role, { expires: 1 });
                    // console.log(userRes.data);
                    navigate(`/integ/${userRes.data.com_id}`);
                }
                setvalue({ uname: '', password: '' });
            } catch (err) {
                toast.error(err.response.data, {
                    autoClose: 1000
                });
                setvalue({ uname: '', password: '' });
            }
        }
        else {
            toast.error('Please Enter User Name and Password', {
                autoClose: 1000
            });
        }
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            submit(e);
        }
    };
    useEffect(() => {
        Cookies.set('openMenu', true, { expires: 1 })
        Cookies.remove('user');
        Cookies.remove('name');
        Cookies.remove('path');
        Cookies.remove('level');
    }, []);
    return (
        <div className='Login_container v_blue df jc'>
            <div className='log_box df fdc jb ac'>
                <div className='h20 w50 df jc ac gap1'>
                    <img src={logo} alt='logo' className='login_logo' />
                    <p className='login_head'>2XCONNECT</p>
                </div>
                <div className='h25 w80 df fdc js ac'>
                    <div className='log_field df h8 w100'>
                        <input
                            type='text'
                            id='uname'
                            name='uname'
                            value={value.uname || ''}
                            onChange={inval}
                            placeholder='User ID'
                            required
                            onKeyDown={handleKeyDown}
                        />
                        <FaUser className='login_icon' />
                    </div>
                    <div className='log_field df h8 w100'>
                        <input
                            type={showPassword ? 'text' : 'password'}
                            id='password'
                            name='password'
                            value={value.password || ''}
                            onChange={inval}
                            placeholder='Password'
                            required
                            onKeyDown={handleKeyDown}
                        />
                        {showPassword ? (
                            <IoEyeOff size={20} className="login_icon" onClick={() => setShowPassword(!showPassword)} />
                        ) : (
                            <IoEye size={20} className="login_icon" onClick={() => setShowPassword(!showPassword)} />
                        )}
                    </div>
                    <div className='log_field h5 w100 df je ac'>
                        <Link to='/forgot_password' className='login_link'><p>Forgot Password?</p></Link>
                    </div>
                </div>
                <div className='h10 w100 df jc ac'>
                    <button type='submit' className='btn green' onClick={submit}>Submit</button>
                </div>
            </div>
            <div className='smart_img'>
                <img src={smart_logo} alt='2xsmart-img' />
            </div>
        </div>
    )
}

export default Login;